// extracted by mini-css-extract-plugin
module.exports = {"homeWrapper":"home_homeWrapper__3x2U5","homeContainer":"home_homeContainer__2SzKQ","homeMain":"home_homeMain__1BJ6Y","rightSide":"home_rightSide__3soEu"};